connect = require 'utils/hocs/connect'

# TODO: deprecate in favor of standard HOC signature
build = ({component, mapStateToProps}) -> connect(mapStateToProps) component

module.exports = {build}
